(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frezyderm-awards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('frezyderm-awards')) {
  customElements.define('frezyderm-awards', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fzw-track');
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-prev]').addEventListener('click', () => { this.paused = true; this.update(); this.move(-1); }, options);
      this.querySelector('[data-next]').addEventListener('click', () => { this.paused = true; this.update(); this.move(1); }, options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.update(); if (!this.paused) this.move(1); }, options);
      this.track.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.track.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.update(); }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) { this.paused = true; this.update(); } }, options);
      this.update();
    }
    update() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(!this.paused));
      if (this.paused) {
        this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
        return;
      }
      this.timer = window.setInterval(() => {
        const rect = this.getBoundingClientRect();
        if (!this.hovered && !this.track.contains(document.activeElement) && !document.hidden && rect.top < innerHeight && rect.bottom > 0) this.move(1);
      }, 4500);
    }
    move(direction) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max < 2) return;
      const card = this.track.querySelector('.fzw-card');
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      let left = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= max - 2) left = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) left = max;
      this.track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frezyderm-journal"]) return;
  try {
    
if (!customElements.get('fz-journal')) {
  customElements.define('fz-journal', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('[data-topic]').forEach(button => button.addEventListener('click', () => this.filter(button.dataset.topic), {signal}));
      const openGuide = () => {
        const target = document.getElementById(window.location.hash.slice(1));
        if (target && this.contains(target) && target.matches('details')) {
          this.filter('all'); target.open = true;
          requestAnimationFrame(() => target.scrollIntoView({block: 'start'}));
        }
      };
      window.addEventListener('hashchange', openGuide, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (link && new URL(link.href).hash === window.location.hash) openGuide();
      }, {signal});
      openGuide();
    }
    filter(topic) {
      this.querySelectorAll('[data-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === topic)));
      this.querySelectorAll('[data-guide-tags]').forEach(card => { card.hidden = topic !== 'all' && !card.dataset.guideTags.split(',').includes(topic); });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frezyderm-routine-category"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fz-routine-add')) {
  customElements.define('fz-routine-add', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const button = this.querySelector('button');
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        const original = button.textContent;
        const status = this.querySelector('[role="status"]');
        button.disabled = true;
        button.textContent = button.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.cartAdd, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: Number(button.dataset.first), quantity: 1}, {id: Number(button.dataset.second), quantity: 1}]}),
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(this.dataset.cart);
        } catch (error) {
          if (error.name !== 'AbortError') {
            status.textContent = this.dataset.error;
            button.disabled = false;
            button.textContent = original;
          }
        }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frezyderm-routines"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fz-routine-add')) {
  customElements.define('fz-routine-add', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const button = this.querySelector('button');
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        const original = button.textContent;
        const status = this.querySelector('[role="status"]');
        button.disabled = true;
        button.textContent = button.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.cartAdd, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: Number(button.dataset.first), quantity: 1}, {id: Number(button.dataset.second), quantity: 1}]}),
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(this.dataset.cart);
        } catch (error) {
          if (error.name !== 'AbortError') {
            status.textContent = this.dataset.error;
            button.disabled = false;
            button.textContent = original;
          }
        }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
if (!customElements.get('fz-cart-coupon')) {
  customElements.define('fz-cart-coupon', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();
        const input = this.querySelector('input');
        const code = input.value.trim();
        if (!code) return;
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        button.disabled = true;
        status.textContent = this.dataset.checking;
        try {
          const response = await fetch(this.dataset.url.replace(/\.js$/, '') + '.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({discount: code})
          });
          const cart = await response.json();
          if (!response.ok || cart.errors) throw new Error();
          const codes = cart.discount_codes || [];
          const allocations = [ ...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application)) ];
          const accepted = codes.some(entry => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable) || allocations.some(entry => (entry.title || '').toLowerCase() === code.toLowerCase());
          if (accepted) window.location.reload();
          else status.textContent = this.dataset.invalid;
        } catch (error) {
          status.textContent = this.dataset.error;
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
